import CommonItemFlag from "components/common-item/CommonItemFlag";
import CommonItemInfo from "components/common-item/CommonItemInfo";
import CommonItemTag from "components/common-item/CommonItemTag";
import useActiveItem from "hooks/useActiveItem";
import { useSoundPath } from "hooks/useSoundPath";
import { MarketplaceContext } from "pages/MarketPlaceCards";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { setactiveItem } from "store/cards";
import MultipleListingInput from "./MultipleListingInput";
import { useLocation } from "react-router-dom";

const MultipleListingItems = ({ items }) => {
  const { pathname } = useLocation();
  const { activeItem } = useActiveItem();
  const playSound = useSoundPath();
  const dispatch = useDispatch();
  const { selectMode, setSelectedItems, selectedItems } =
    useContext(MarketplaceContext);

  return (
    <ul
      className={`cards-list__block ${
        items.length | activeItem && "cards-list__block--min"
      }`}
    >
      {items.map((item) => (
        <li
          key={item.id}
          className={`
            cards-list__block-item
            ${activeItem === item ? "active" : ""}
          `}
          onClick={() => {
            dispatch(setactiveItem(item));
            playSound("main");
          }}
        >
          <CommonItemInfo
            name={item.name}
            type={item.type}
            image={item.image}
            props={item.properties}
          />
          <p
            className={`cards-list__block-item-text ${
              selectMode ? "cards-list__block-item-text--select-mode" : ""
            }`}
          >
            <span>
              {item.type.toLowerCase() === "prize" && "$"}
              {item.name}
            </span>

            {selectMode && (
              <MultipleListingInput
                id={item.marketplace_id}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
              />
            )}
          </p>
          {pathname.includes("/marketplace") && item.tag === "For Sale" ? (
            <p className="cards-list__block-item-rarity">${item.cost} USD</p>
          ) : null}
          <CommonItemTag tag={item.tag} />
          <CommonItemFlag
            isListed={item.is_listed}
            isMine={item.owned_by_self}
          />
        </li>
      ))}
    </ul>
  );
};

export default MultipleListingItems;
